// import React from "react";

// const ContactUs = () => {
//   return (
//     <>


//  <div className="breadcrumb-bar">
//         <div className="container">
//           <div className="row align-items-center text-center">
//             <div className="col-md-12 col-12">
//               <h2 className="breadcrumb-title text-white">Contact Us</h2>
//             </div>
//           </div>
//         </div>
//       </div>


   

//       {/* CONTACT SECTION */}
//       <div className="shivai-contact-section">
//         <div className="container">

//           <div className="row">

//             {/* PHONE */}
//             <div className="col-md-4">
//               <div className="shivai-card">
//                 <div className="icon-box">
//                   <i className="fa-solid fa-phone"></i>
//                 </div>
//                 <h3>Call Us</h3>
//                 <a href="tel:+919689815477">+91 9689815477</a>
//               </div>
//             </div>

//             {/* EMAIL */}
//             <div className="col-md-4">
//               <div className="shivai-card">
//                 <div className="icon-box">
//                   <i className="fa-solid fa-envelope"></i>
//                 </div>
//                 <h3>Email Us</h3>
//                 <a href="mailto:booking@shivaitravels.com">
//                   booking@shivaitravels.com
//                 </a>
//               </div>
//             </div>

//             {/* ADDRESS */}
//             <div className="col-md-4">
//               <div className="shivai-card">
//                 <div className="icon-box">
//                   <i className="fa-solid fa-location-dot"></i>
//                 </div>
//                 <h3>Our Office</h3>
//                 <h6>Shivai Travels</h6>
//                 <p>Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105</p>
//               </div>
//             </div>

//           </div>

//         </div>
//       </div>

  


// <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2711.572127679856!2d73.9067687!3d18.6878115!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c9ad5f29512f%3A0x68cc8bf67473b0b6!2sShivai%20tours%20%26%20travels!5e1!3m2!1sen!2sin!4v1778688240010!5m2!1sen!2sin" width="100%" height="450"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
//     </>
//   );
// };

// export default ContactUs;





import React from "react";

const ContactUs = () => {
  return (
    <div className="contact-page">

      {/* HERO */}
      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white">Contact Us</h2>
            </div>
          </div>
        </div>
      </div>

      {/* CONTACT CARDS */}
      <div className="contact-section">
        <div className="contact-container">

          <div className="contact-grid">

            <div className="contact-card call">
              <div className="icon">📞</div>
              <h3>Call Us</h3>
              <a href="tel:+919689815477">+91 9689815477</a>
            </div>

            <div className="contact-card email">
              <div className="icon">📧</div>
              <h3>Email Us</h3>
              <a href="mailto:booking@shivaitravels.com">
                booking@shivaitravels.com
              </a>
            </div>

            <div className="contact-card location">
              <div className="icon">📍</div>
              <h3>Our Office</h3>
               <h6>Shivai Travels</h6>
              <p>
                Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
              </p>
            </div>

          </div>

        </div>
      </div>

      {/* MAP */}
      <div className="map-section">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2711.572127679856!2d73.9067687!3d18.6878115!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c9ad5f29512f%3A0x68cc8bf67473b0b6!2sShivai%20tours%20%26%20travels!5e1!3m2!1sen!2sin!4v1778688240010!5m2!1sen!2sin"
          width="100%"
          height="450"
        />
      </div>

    </div>
  );
};

export default ContactUs;